import React from 'react'

import classNames from 'classnames'

import styles from './index.module.css'

export interface Props {
  /**
   * Value to display
   */
  children: React.ReactNode

  /**
   * Optional classes to add
   */
  className?: string

  /**
   * Maximum number of rows to display
   */
  maxRows?: number

  /**
   * Dimension
   */
  size?: 'XS' | 'S' | 'M' | 'L'
}

const Paragraph: React.FC<Props> = ({
  children,
  className,
  maxRows,
  size = 'S',
}: Props): JSX.Element | null => {
  if (!Boolean(children)) {
    return null
  }

  return (
    <div
      className={classNames(
        styles.main,
        styles[`rows-${maxRows}`],
        styles[`size-${size.toLowerCase()}`],
        className
      )}
    >
      {children}
    </div>
  )
}

export default Paragraph
